module.exports = __webpack_public_path__ + "img/index-introduce.0764244e.jpg";